import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ArrowRight from '@deliveroo/icon-set/react/ArrowRight';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';
import P from '@deliveroo/consumer-component-library/components/P';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import CCLRichText from '@deliveroo/consumer-component-library/components/RichText';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';

import styles from './styles.scss';

/**
 * A component to display a brief synopsis of an external blog post, i.e. from Foodscene.
 */
class RichTextLongCard extends React.Component {
  validateProps({ callToActionUrl, image, title, bodyRichText, callToActionText }) {
    return (
      typeof callToActionUrl === 'string' &&
      typeof image === 'string' &&
      typeof title === 'string' &&
      typeof bodyRichText === 'string' &&
      typeof callToActionText === 'string'
    );
  }

  componentDidMount() {
    const { callToActionUrl, image, title, bodyRichText, callToActionText } = this.props;

    if (!this.validateProps({ callToActionUrl, image, title, bodyRichText, callToActionText })) {
      throw new Error(`Incorrect prop-types for Storyblok RichTextLongCard component`);
    }
  }

  render() {
    const { callToActionUrl, image, title, bodyRichText, callToActionText } = this.props;
    return (
      <Spacer spacing="medium 0">
        <article className={styles.card}>
          <div className={styles.cardBody}>
            <span className={styles.image}>
              <BackgroundImage src={image} />
            </span>

            <div className={styles.details}>
              <Heading level={3} size="x-small">
                {title}
              </Heading>
              <P color="grey" adjacentVerticalSpacing="small">
                <CCLRichText>
                  {/* this output is already sanitised by Storybook's markdown-html plugin */}
                  {/* eslint-disable-next-line react/no-danger */}
                  <div dangerouslySetInnerHTML={{ __html: bodyRichText }} />
                </CCLRichText>
              </P>
            </div>
          </div>
          {callToActionUrl &&
            callToActionText && (
              <Fragment>
                <hr className={styles.divider} />
                {callToActionUrl && (
                  <div className={styles.callToAction}>
                    <P adjacentVerticalSpacing="medium">
                      <a href={callToActionUrl} className={styles.linkText}>
                        {callToActionText}
                        <Icon component={ArrowRight} size={18} spacing="0 0 0 x-small" />
                      </a>
                    </P>
                  </div>
                )}
              </Fragment>
            )}
        </article>
      </Spacer>
    );
  }
}

RichTextLongCard.propTypes = {
  /**
   * URL for the blog post, which the card links to.
   */
  callToActionUrl: PropTypes.string.isRequired,
  /**
   * URL for the image to be displayed on the card.
   */
  image: PropTypes.string.isRequired,
  /**
   * Title of the blog post.
   */
  title: PropTypes.string.isRequired,
  /**
   * Excerpt of the blog post.
   */
  bodyRichText: PropTypes.string.isRequired,
  /**
   * Text for the link to the blog post.
   */
  callToActionText: PropTypes.string,
};

RichTextLongCard.defaultProps = {
  callToActionText: 'Read more',
};

export default RichTextLongCard;
